import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Box from '@material-ui/core/Box';
import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Link as MUILink } from '@material-ui/core';
import { useEffect } from 'react';

const useStyles = makeStyles(theme => ({
    Toolbar: {
        flexGrow: 1        
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    Logo : {
        [theme.breakpoints.down('md')] : {
            width: '180px'
        }
    }
}));

const useSDStyles = makeStyles(theme => ({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    link: {
        textDecoration: 'none !important',
        color: theme.palette.text.primary,        
    }
}));

function SideDrawer(props) {

    const [open, setOpen] = React.useState(false);    
    const classes = useSDStyles();

    useEffect(()=> {
        setOpen(props.isOpen || false)
    },[props.isOpen])

    return (
        <React.Fragment key={'sideMenu'}>            
            <Drawer open={open} onClose={() => setOpen(false)}>
                <div className={classes.list}>
                    <List>
                        {[['Agroads', 'https://www.agroads.com.ar'], ['Agroads Analytics', 'https://www.agroads.com.ar/analytics/']].map((elem, index) => (
                            <React.Fragment key={elem[0]}>
                                <ListItem button>                                
                                    <ListItemText>
                                        <MUILink variant="body" className={classes.link} href={elem[1]}>{elem[0]}</MUILink>
                                    </ListItemText>                                
                                </ListItem>                                                        
                            </React.Fragment>
                        ))}                        
                    </List>                                       
                </div>
            </Drawer>
        </React.Fragment>
    )
}

export default function CustomAppBar(props){
    const classes = useStyles();
    const [sideDrawerOpen, setSideDrawerOpen] = React.useState(false);
    
    const toggleSideDrawerOpen = () => {
        setSideDrawerOpen(prevState => (prevState) => !prevState)
    }

    return (
        <React.Fragment>
            <AppBar position="sticky">
                <Toolbar className={classes.Root}>
                    <IconButton onClick={toggleSideDrawerOpen} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                        <MenuIcon />
                    </IconButton>
                    <Box className={classes.MenuCenterBox}>
                        <Link to={'/'}><img className={classes.Logo}src="https://s3.amazonaws.com/static-1.agroads.com.ar/img/referencias-de-precios/img/Agroads_Precios_logo.png" alt="agroads Precios" width="250px"></img></Link>
                    </Box>                    
                </Toolbar>
                <SideDrawer isOpen={sideDrawerOpen} />
            </AppBar>
            { props.loading
                ? <LinearProgress></LinearProgress>
                : null
            }        
        </React.Fragment>
    )
}